(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schwarz-metallkurse"] && !Shopify.designMode) return;
  try {
    
(() => {
 if (customElements.get('schwarz-metallkurse')) return;
 class SchwarzMetallkurse extends HTMLElement {
  connectedCallback() {
   if(this.timer) return;
   this.unit='gram';this.prices=null;
   this.clickHandler=(event)=>{const button=event.target.closest('button');if(!button||!this.contains(button))return;if(button.dataset.unit){this.unit=button.dataset.unit;this.querySelectorAll('[data-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.render();}else if(button.classList.contains('smk-refresh'))this.load();};
   this.addEventListener('click',this.clickHandler);
   this.visibilityHandler=()=>{if(!document.hidden)this.load();};document.addEventListener('visibilitychange',this.visibilityHandler);
   this.timer=setInterval(()=>{if(!document.hidden)this.load();},300000);this.load();
  }
  disconnectedCallback(){clearInterval(this.timer);this.timer=null;this.controller?.abort();this.removeEventListener('click',this.clickHandler);document.removeEventListener('visibilitychange',this.visibilityHandler);}
  render(){const factor={gram:1,ounce:31.1034768,kilogram:1000}[this.unit];const label={gram:'Gramm',ounce:'Feinunze',kilogram:'Kilogramm'}[this.unit];const format=new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'});this.querySelectorAll('[data-metal]').forEach(card=>{card.querySelector('.smk-value').textContent=this.prices?format.format(this.prices[card.dataset.metal]*factor):'—';card.querySelector('.smk-unit').textContent='EUR pro '+label;});}
  async load(){
   if(this.loading)return;this.loading=true;const button=this.querySelector('.smk-refresh');button.disabled=true;
   const controller=new AbortController();this.controller=controller;const timeout=setTimeout(()=>controller.abort(),12000);
   try{
    const response=await fetch(this.dataset.api,{signal:controller.signal,credentials:'omit',cache:'no-store'});if(!response.ok)throw new Error('unavailable');const data=await response.json();if(data.success!==true)throw new Error('invalid');
    const prices={};for(const key of ['gold','silver','platinum','palladium']){const value=Number(data.prices?.[key]??data.materials?.[key]?.[0]?.basePerGr);if(!Number.isFinite(value)||value<=0)throw new Error('invalid');prices[key]=value;}
    const stamp=typeof data.timestamp==='number'?new Date(data.timestamp*1000):new Date(data.timestamp);const age=Date.now()-stamp.getTime();if(!Number.isFinite(age)||age>7200000||age< -300000)throw new Error('outdated');
    if(data.currency&&data.currency!=='EUR')throw new Error('currency');if(data.unit&&data.unit!=='gram')throw new Error('unit');
    this.prices=prices;this.render();this.querySelector('.smk-status').textContent=(data.stale?'Letzter verfügbarer Kursstand: ':'Kursstand: ')+new Intl.DateTimeFormat('de-DE',{dateStyle:'medium',timeStyle:'short',timeZone:'Europe/Berlin'}).format(stamp)+' Uhr (Deutschland)'+(data.stale?' · Aktualisierung derzeit verzögert.':'');
   }catch(error){if(!this.isConnected)return;this.prices=null;this.render();this.querySelector('.smk-status').textContent='Aktuelle Kurse sind vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.';}
   finally{clearTimeout(timeout);this.loading=false;button.disabled=false;}
  }
 }
 customElements.define('schwarz-metallkurse',SchwarzMetallkurse);
})();

  } catch(e) { console.error(e); }
})();
})();
